import { Component, OnInit } from '@angular/core'

@Component({
    selector: 'app-legales',
    templateUrl: './legales.component.html',
    styleUrls: ['./legales.component.scss'],
    standalone: false
})
export class LegalesComponent implements OnInit {
  textoLegales: string

  constructor() {}

  ngOnInit() {
    this.textoLegales = `
    
<p style="font-size: var(--small) !important;"><strong>Protecci&oacute;n de Datos Personales</strong></p>
<p style="font-size: var(--small) !important;">El titular de los datos personales tiene la facultad de ejercer el derecho de acceso a los mismos en forma gratuita a intervalos no inferiores a seis meses, salvo que se acredite un inter&eacute;s leg&iacute;timo al efecto conforme lo establecido en el art&iacute;culo 14, inciso 3 de la Ley N&ordm; 25.326. LA AGENCIA DE ACCESO A LA INFORMACI&Oacute;N P&Uacute;BLICA, en su car&aacute;cter de &Oacute;rgano de Control de la Ley N&deg; 25.326, tiene la atribuci&oacute;n de atender las denuncias y reclamos que interpongan quienes resulten afectados en sus derechos por incumplimiento de las normas vigentes en materia de protecci&oacute;n de datos personales. El titular podr&aacute; en cualquier momento solicitar el retiro o bloqueo de su nombre de los bancos de datos y/o el responsable o usuario que provey&oacute; la informaci&oacute;n. <strong><a target="_blank" href="https://www.comafi.com.ar/1752-Proteccion-de-Datos-Personales.note.aspx">VER M&Aacute;S</a></strong> </p>
 
  `
  }
}
